import { required, email } from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'

extend('required', {
  ...required,
  message: field => '请填写' + field
})

extend('email', {
  ...email,
  message: field => field + '不正确'
})
extend('mobile', {
  validate: value => /^1[3456789]\d{9}$/.test(value),
  message: '手机号码 不正确'
})
extend('age', {
  validate: value => value >= 16 && value <= 25,
  message: '16至25岁才能参加'
})
// extend("age", {
//     validate: value => value<=25,
//     message: "23岁以下才能参加"
// });
